import React, { Component } from 'react';
import moment from 'moment'

export default class CustomerStatistics extends Component {
    render() {
        let lastCheckIn = '-';
        if( this.props.statistics && this.props.statistics.lastCheckIn ) {
            const dateObj = new Date(this.props.statistics.lastCheckIn);
            lastCheckIn = moment(dateObj).format('MMM D - YYYY')
        }

        return (
            <div>
                <label className="box-label">Customer Statistics</label>
                <div className="customer-statistics">
                    <div className="row">
                        <div className="col-md-2 col-xs-6 card">
                            <h4>{this.props.statistics.checkIns || 0}</h4>
                            <div className="card-label">
                                <label>Entry Events (Last 12 Months)</label>
                            </div>
                        </div>
                        <div className="col-md-2 col-xs-6 card">
                            <h4>{lastCheckIn}</h4>
                            <div className="card-label">
                                <label>Last Check In</label>
                            </div>
                        </div>
                        <div className="col-md-2 col-xs-6 card">
                            <h4>{this.props.statistics.zoneTotal}</h4>
                            <div className="card-label">
                                <label>Zones</label>
                            </div>
                        </div>
                        <div className="col-md-2 col-xs-6 card">
                            <h4>{this.props.statistics.projects}</h4>
                            <div className="card-label">
                                <label>Projects</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
